import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "d627caf2-5843-413c-8482-68db114c7394"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterD627caf25843413c848268db114c7394(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterD627caf25843413c848268db114c7394 footer`}>
      {props["links"] || <Navigation className="LinksEf52daa3Dcbf43838bf25db455ecdd51" parentTag={buildClassName("LinksEf52daa3Dcbf43838bf25db455ecdd51", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo58a183425c9f4d5eA8016277b8365131" parentTag={buildClassName("Logo58a183425c9f4d5eA8016277b8365131", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightBa9c813809f64af29785Ae78f1244564" parentTag={buildClassName("CopyrightBa9c813809f64af29785Ae78f1244564", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow758d4d06086b4baaA6f3C1bcc8dd8458" parentTag={buildClassName("Groupflow758d4d06086b4baaA6f3C1bcc8dd8458", parentTag)} {...props} />}
    </footer>
  );
}

// id: "58a18342-5c9f-4d5e-a801-6277b8365131"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "d627caf2-5843-413c-8482-68db114c7394"
export function Logo58a183425c9f4d5eA8016277b8365131(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo58a183425c9f4d5eA8016277b8365131" parentTag={buildClassName("Logo58a183425c9f4d5eA8016277b8365131", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "ba9c8138-09f6-4af2-9785-ae78f1244564"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "d627caf2-5843-413c-8482-68db114c7394"
export function CopyrightBa9c813809f64af29785Ae78f1244564(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightBa9c813809f64af29785Ae78f1244564" parentTag={buildClassName("CopyrightBa9c813809f64af29785Ae78f1244564", parentTag)} {...props} />
  );
}

// id: "ef52daa3-dcbf-4383-8bf2-5db455ecdd51"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "d627caf2-5843-413c-8482-68db114c7394"
export function LinksEf52daa3Dcbf43838bf25db455ecdd51(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksEf52daa3Dcbf43838bf25db455ecdd51" parentTag={buildClassName("LinksEf52daa3Dcbf43838bf25db455ecdd51", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "758d4d06-086b-4baa-a6f3-c1bcc8dd8458"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "d627caf2-5843-413c-8482-68db114c7394"
export function Groupflow758d4d06086b4baaA6f3C1bcc8dd8458(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow758d4d06086b4baaA6f3C1bcc8dd8458" parentTag={buildClassName("Groupflow758d4d06086b4baaA6f3C1bcc8dd8458", parentTag)} {...props} />
  );
}

// id: "0ff13fc6-44e5-41e3-adf1-d716d89b5799"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "58a18342-5c9f-4d5e-a801-6277b8365131"
export const LogoType0ff13fc644e541e3Adf1D716d89b5799 = "FOOTER";

// id: "7fdfb5c8-0a42-49b8-8a34-bbe5f2461935"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "ef52daa3-dcbf-4383-8bf2-5db455ecdd51"
export const NavMenuSlug7fdfb5c80a4249b88a34Bbe5f2461935 = "footer-nav";

// id: "9e04d7db-0aa1-43fe-bebf-87a80d946a39"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "58a18342-5c9f-4d5e-a801-6277b8365131"
export const ContentSlug9e04d7db0aa143feBebf87a80d946a39 = "footer-logo";

const Components = {
  DefaultFooterD627caf25843413c848268db114c7394,
  Logo58a183425c9f4d5eA8016277b8365131,
  CopyrightBa9c813809f64af29785Ae78f1244564,
  LinksEf52daa3Dcbf43838bf25db455ecdd51,
  Groupflow758d4d06086b4baaA6f3C1bcc8dd8458,
  LogoType0ff13fc644e541e3Adf1D716d89b5799,
  NavMenuSlug7fdfb5c80a4249b88a34Bbe5f2461935,
  ContentSlug9e04d7db0aa143feBebf87a80d946a39
}

export default Components;